// frontend/src/marketing/useLivePrices.ts
//
// Live module pricing for marketing pages. Returns null until the fetch
// resolves (or if it fails) — callers render their hardcoded fallbacks in
// that case, so the page never blanks or layout-shifts on a dead backend.
import * as React from 'react';
import { getPublicPrices, type PriceMap } from './api';

export function useLivePrices(): PriceMap | null {
  const [prices, setPrices] = React.useState<PriceMap | null>(null);

  React.useEffect(() => {
    let cancelled = false;
    getPublicPrices().then((p) => { if (!cancelled && p) setPrices(p); });
    return () => { cancelled = true; };
  }, []);

  return prices;
}
